import axios from 'axios';

import { AXIOS_DEFAULT_CONFIG, routes } from '../../constants';


export default async function listCreated() {
  const { data } = await axios.get(routes.ordersCreatedIndex, AXIOS_DEFAULT_CONFIG);
  return data;
}
